// import React from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { Card, Container, Row, Col } from 'react-bootstrap';
// import Image1 from "../../assets/images/simage-3.jpeg";
// import Image2 from "../../assets/images/simage-1.jpeg";
// import Image3 from "../../assets/images/simage-2.jpeg";
// import "../strong/Strong.css";

// function Strong() {
//   const cardData = [
//     {
//       image: Image1,
//       name: "Mr. B.K. Mohanka",
//       role: "Chairman",
//       experience: "50+ Years of Business Experience",
//       details: [
//         "Visionary to start Solar Business in 1998.",
//         "Engineering Graduate from NIT Patna, Among Top Ranked Universities in India",
//         "Ex. Professor in Engineering College",
//       ],
//     },
//     {
//       image: Image3,
//       name: "Mr. Gautam Mohanka",
//       role: "CEO",
//       experience: "22+ Years of Solar Industry Experience",
//       details: [
//         "Holds a number of Patents & Design Registrations for Several Technical Innovations in Solar Industry",
//         "Eco (Hons.) from Shri Ram College of Commerce (SRCC), one of India’s Top Colleges",
//         "MBA from MDI Gurgaon",
//       ],
//     },
//     {
//       image: Image2,
//       name: "Mr. Sharad Mohanka",
//       role: "Director",
//       experience: "14+ Years of Solar Industry Experience",
//       details: [
//         "Capacity Expansion & Managing Manufacturing Operation",
//         "BE Engineering Graduate, Mumbai University",
//         "M. Tech from North Carolina State University (NCSU), Raleigh, USA",
//       ],
//     },
//   ];

//   return (
//     <Container fluid className="py-5 "> {/* Add padding to the Container */}
//        <div className="row py-5" style={{ overflowX: 'hidden' }}>
//     <div className="col-lg-10 col-md-12 mx-auto text-center">
//         <h2 className=" textRes" style={{ position: 'relative', color: 'black' }}>
//             <span style={{fontSize:"55px", position: 'absolute', top: '-15px', left: '50%', transform: 'translateX(-50%)', borderBottom: '2px solid #faab04', width: '50px' }}></span>
//             <span style={{ color: "#a20000" }}> Strong </span>  Top Management
//           </h2>
//         </div>
//       </div>
//       <p p-1 className="text-center">Gautam Solar’s Top Management comprises experienced solar industry leaders with top-notch technical skills and graduates from top colleges in India & US. With a long-term vision for the company’s sustained growth, they have built a legacy of excellence and trust.</p>
//       <br />

//       {cardData.map((card, index) => (
//         <Row key={index} className="mb-3">
//           <Col xs={12} md={12}>
//             <Card  style = {{maxWidth:"90%"}}className=" card1 p-5 ">
//               <Row className="align-items-center">
//                 <Col xs={12} md={4} className="text-center mb-3 mb-md-0">
//                   <Card.Img style={{ width: "200px" }} variant="top" src={card.image} alt={card.name} />
//                   <Card.Title >{card.name}</Card.Title>
//                   <Card.Subtitle className="mb-2 text-muted">{card.role}</Card.Subtitle>
//                 </Col>
//                 <Col xs={12} md={8}>
//                   <Card.Body>
//                     <Card.Text className="mb-3" style={{ fontSize: "1.2rem", color: "black" }}>{card.experience}</Card.Text>
//                     <ul style={{ fontSize: "1.2rem", color: "gray", padding: "10px" }}>
//                       {card.details.map((detail, i) => (
//                         <li key={i}>{detail}</li>
//                       ))}
//                     </ul>
//                     <div style={{ borderBottom: "2px solid #a20000", width: "35%" }} className="line"></div>
//                   </Card.Body>
//                 </Col>
//               </Row>
//             </Card>
//           </Col>
//         </Row>
//       ))}
//     </Container>
//   );
// }

// export default Strong;


import { Card, Container, Row, Col } from 'react-bootstrap';
import Image1 from "../../assets/images/simage-3.jpeg";
import Image2 from "../../assets/images/simage-1.jpeg";
import Image3 from "../../assets/images/simage-2.jpeg";
import "../strong/Strong.css";

function Strong() {
  const cardData = [
    {
      image: Image1,
      name: "Mr. B.K. Mohanka",
      role: "Chairman",
      experience: "51+ Years of Business Experience",
      details: [
        "Visionary to start Solar Business in 1997.",
        "Engineering Graduate from NIT Patna, Among Top Ranked Universities in India",
        "Ex. Professor in Engineering College",
      ],
    },
    {
      image: Image3,
      name: "Mr. Gautam Mohanka",
      role: "Director",
      experience: "23+ Years of Solar Industry Experience",
      details: [
        "Holds a number of Patents & Design Registrations for Several Technical Innovations in Solar Industry",
        "Eco (Hons.) from Shri Ram College of Commerce (SRCC), one of India’s Top Colleges",
        "MBA from MDI Gurgaon",
      ],
    },
    {
      image: Image2,
      name: "Mr. Sharad Mohanka",
      role: "Director",
      experience: "15+ Years of Solar Industry Experience",
      details: [
        "Capacity Expansion & Managing Manufacturing Operation",
        "BE Engineering Graduate, Mumbai University",
        "M. Tech from North Carolina State University (NCSU), Raleigh, USA",
      ],
    },
  ];

  return (
    <Container fluid className="py-5 border-top">
      <Row className="justify-content-center mb-4">
        <Col xs={12} md={10} className="text-center">
          <h2 className="strong-section-title text-black">
            <span style={{ color: "#a20000" }}>Strong Top</span> Management
          </h2>
          <p className="mt-3" style={{ color: "#333", fontSize: "1.15rem" }}>
            Gautam Solar’s Top Management comprises experienced solar industry leaders with top-notch technical skills and graduates from top colleges in India & US. With a long-term vision for the company’s sustained growth, they have built a legacy of excellence and trust.
          </p>
        </Col>
      </Row>

      <Row className="justify-content-center">
        {cardData.map((card, index) => (
          <Col
            key={index}
            xs={12}
            md={6}
            lg={4}
            className="d-flex align-items-stretch mb-4"
          >
            <Card className="strong-card p-4 w-100 py-3">
              <div className="text-center">
                <img
                  className="strong-card-img"
                  // variant="top"
                  src={card.image}
                  alt={card.name}
                />
                <p className="strong-card-title">{card.name}</p>
                <p className="text-black mb-2">{card.role}</p>
                <div className="strong-card-exp">{card.experience}</div>
              </div>
              <Card.Body className="pt-2">
                <ul className="strong-card-details">
                  {card.details.map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>
                <div className="strong-card-divider mx-auto" />
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Strong;
